<div class="login-dialog-container login col-md-12">
  <div class="login-box">
    <div class="logo-box mb-2">
      <mat-icon aria-hidden="false" class="icon-live-logo mr-2" svgIcon="logo_v2"></mat-icon>
      <mat-icon aria-hidden="false" class="icon-ccj-logo" svgIcon="ccj_logo"></mat-icon>
    </div>
    <div class="text-center">
      <div class="title mb-3">CAREKARTE <span class="live-effect-color">Live</span> CCJ Console</div>
      <div *ngIf="isError" class="error-container mb-8-px">{{ 72 | mstMessageImpure }}</div>
      <div class="small-title mt-2 mb-3">{{ 'LOGIN.TITLE' | translate }}</div>
    </div>
    <form #loginForm="ngForm" (ngSubmit)="onLogin()" novalidate class="custom-form">
      <div class="mt-12 d-flex flex-column justify-content-center col-gap-32 mb-3">
        <div class="label">{{ 'LOGIN.USER_NAME_LABEL' | translate }}</div>
        <mat-form-field [ngClass]="{'border-error-color': isError && !loginModel.email}" appearance="outline" class="custom-form-field no-bottom field-title error-static">
          <input class="input-field" id="title" name="title" [(ngModel)]="loginModel.email" latinOnly matInput noSpaces
            #email="ngModel" maxlength="120" autocomplete="email"
          >
        </mat-form-field>
      </div>
      <div class="mt-12 mb-2 d-flex flex-column justify-content-center col-gap-32">
        <div>
          <span class="label">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</span>
        </div>
        <mat-form-field [ngClass]="{'border-error-color': isError && !loginModel.password}" appearance="outline" class="custom-form-field no-bottom field-title error-static">
          <input class="input-field" id="password" [type]="isShowPassword ? 'text' : 'password'" name="password" [(ngModel)]="loginModel.password" latinOnly matInput noSpaces
            maxlength="120" autocomplete="password"
          >
        </mat-form-field>
      </div>
      <div class="mb-40-px">
        <mat-checkbox
          class="show-pw-check-box mr-2"
          color="primary"
          #isHidePopupCheckbox="ngModel"
          matInput
          name="isShowPassword"
          (change)="onChangeCheckboxShowPassword($event)"
          [(ngModel)]="isShowPassword"
        >
        </mat-checkbox>
        <span>{{ 'LOGIN.SHOW_PASSWORD' | translate }}</span>
      </div>
      <div class="mt-12 mb-4 d-flex flex-column justify-content-center col-gap-32">
        <button type="submit" mat-flat-button class="btn-custom">
          {{ 'LOGIN.LOGIN' | translate }}
        </button>
      </div>
      <div class="mt-12 d-flex flex-column align-items-center justify-content-center col-gap-32">
        <span (click)="goForgotPassword()" class="button-link">
          {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
        </span>
      </div>
    </form>
  </div>
</div>
